// Register component hooks from packages (e.g. vue-router)
import './importThisFileFirst';
import Style from '@openticket/lib-style';
import { Whitelabel, type WhitelabelInitConfig } from '@openticket/lib-whitelabels';
import { VueDashboardComponents } from '@openticket/vue-dashboard-components';
import '@openticket/vue-dashboard-components/lib/style.css';
import { VueIcons } from '@openticket/vue-icons';
import { VueInput } from '@openticket/vue-input';
import '@openticket/vue-input/style.css';
import { VueLocalization } from '@openticket/vue-localization';
import '@openticket/vue-localization/lib/style.css';
import VueNotifications from '@openticket/vue-notifications';
import { VueTFAConfirmationPlugin } from '@openticket/vue-tfa-confirmation';
import '@openticket/vue-tfa-confirmation/lib/style.css';
import Vue, { type CreateElement } from 'vue';
import App from './App.vue';
import { registerComponents } from './components';
import { createRouter } from './router';
import './assets/scss/index.scss';

Vue.use(VueLocalization);
Vue.use(VueIcons);
Vue.use(VueInput);
Vue.use(VueDashboardComponents);
Vue.use(VueNotifications, { singleNotification: true });
Vue.use(VueTFAConfirmationPlugin);

// Register local components
Vue.use(registerComponents);

const whitelabelConfig: Partial<WhitelabelInitConfig> = {};
if (import.meta.env.VITE_WHITELABEL_CONFIG_URL) {
    whitelabelConfig.url = import.meta.env.VITE_WHITELABEL_CONFIG_URL;
}
const $whitelabel = new Whitelabel(whitelabelConfig);
void $whitelabel.loadStylesheet();
void $whitelabel.loadIconPack();
void $whitelabel.setFavicon();
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
Vue.prototype.$whitelabel = $whitelabel;

const style = new Style({});
style.initColorSchemeListener();
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
Vue.prototype.$style = style;

Vue.config.productionTip = false;

const app = new Vue({
    router: createRouter(), // TODO @Peter, still needed?
    render: (h: CreateElement) => h(App),
});

app.$mount('#app');
